/**
 * distanceUtils.js
 * Frontend helper
 * Calls backend API (Google Distance Matrix)
 */

import { apiRequest } from "./api";

export async function calculateTripMetrics(from, to) {
  if (!from || !to) return { distanceKm: 0, durationMinutes: 0 };
  try {
    const data = await apiRequest("/distance", {
      method: "POST",
      body: JSON.stringify({ from, to })
    });
    return {
      distanceKm: data.distanceKm || 0,
      durationMinutes: data.durationMinutes || 0
    };
  } catch {
    return { distanceKm: 0, durationMinutes: 0 };
  }
}

export async function calculateDistanceKm(from, to) {
  const metrics = await calculateTripMetrics(from, to);
  return metrics.distanceKm;
}
